var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConditionIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10632_187245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0895 5.5H7.14486C6.8723 5.5 6.61091 5.60827 6.41818 5.801C6.22546 5.99372 6.11719 6.25511 6.11719 6.52767V17.4621C6.11719 17.7346 6.22546 17.996 6.41818 18.1887C6.61091 18.3815 6.8723 18.4897 7.14486 18.4897H18.0895C18.3621 18.4897 18.6235 18.3815 18.8162 18.1887C19.0089 17.996 19.1172 17.7346 19.1172 17.4621V6.52767C19.1172 6.25511 19.0089 5.99372 18.8162 5.801C18.6235 5.60827 18.3621 5.5 18.0895 5.5ZM12.8279 7.617V9.03518H12.3346V7.617H12.8279ZM17.0619 16.4344H8.17252V7.55534H10.2792V10.0628C10.2792 10.3354 10.3875 10.5968 10.5802 10.7895C10.773 10.9822 11.0344 11.0905 11.3069 11.0905H13.8555C14.1281 11.0905 14.3895 10.9822 14.5822 10.7895C14.7749 10.5968 14.8832 10.3354 14.8832 10.0628V7.55534H17.0619V16.4344Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10632_187245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(6.11719 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditionIcn);
export default __webpack_public_path__ + "static/media/condition-icn.c82d167bcf12d2758d7b45d06e1ad08e.svg";
export { ForwardRef as ReactComponent };